module.exports = __webpack_public_path__ + "img/20180815_150347_076.bd147342.jpg";